import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule,ReactiveFormsModule, FormArray } from '@angular/forms';
import { AgendaService } from '../services/agenda.service';
import { LoadingModalComponent } from "../../../../loading-modal/loading-modal.component";
import { MatIcon } from "@angular/material/icon";

enum DayOfWeek {
   Domingo = 0,
   Segunda = 1,
   Terca = 2,
   Quarta = 3,
   Quinta = 4, 
   Sexta = 5, 
   Sabado = 6
}

type NovaAgenda = {
  name: string;
  configSchedule: Array<ConfigAgenda>;
}


type ConfigAgenda = {
  dayOfWeek: DayOfWeek,
  isActive: boolean,
  startHour: string | null,
  endHour: string | null,
  hasBreak: boolean,
  breakStart: string | null,
  breakEnd: string | null,
  appointmentDuration: string,
  createdAt: Date, 
  updatedAt: Date
}



@Component({
  selector: 'app-novaagenda',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LoadingModalComponent, MatIcon],
  standalone: true,
  templateUrl: './novaagenda.component.html',
  styleUrls: ['./novaagenda.component.scss'],
  providers: [DatePipe],
})
export class NovaagendaComponent  implements OnInit {
  @Input() isModalOpen: boolean = false;
  @Output() closeModal = new EventEmitter<any>();

  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  //Variaveis do formulario de cadastro de agenda
  public formCadAgenda: FormGroup;


  public diasSemana = [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado'
  ];

  constructor(private fb: FormBuilder, private datePipe: DatePipe, private agendaService: AgendaService) {
    this.formCadAgenda = this.fb.group({
      name: ['', [Validators.required]],
      configSchedule: this.fb.array([
        this.fb.group({
          dayOfWeek: 0,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
        this.fb.group({
          dayOfWeek: 1,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
        this.fb.group({
          dayOfWeek: 2,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
        this.fb.group({
          dayOfWeek: 3,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
        this.fb.group({
          dayOfWeek: 4,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
        this.fb.group({
          dayOfWeek: 5,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
        this.fb.group({
          dayOfWeek: 6,
          isActive: false,
          startHour: "08:00",
          endHour: "17:00",
          hasBreak: false,
          breakStart: "12:00",
          breakEnd: "13:00",
          appointmentDuration: "00:30",
          createdAt: this.datePipe.transform(new Date())?.toString(),
          updatedAt: this.datePipe.transform(new Date())?.toString()
        }),
      ])
    })
   }

  ngOnInit() {
  }


  handleCloseModal(): void {
    console.log("Fechando o modal...")
    this.formCadAgenda.reset();
    this.closeModal.emit('Close');
  }

  handleSubmit(){
    console.log(this.formCadAgenda.value);
    this.loadingComponent.activeLoading();
    this.agendaService.createAgenda(this.formCadAgenda.value).subscribe((response: any)=> {
      console.log(response);
      this.handleCloseModal();
      this.loadingComponent.inactiveLoading();
    }, (error: any)=> {
      this.loadingComponent.inactiveLoading();
    })
  }

  get configSchedule(): FormArray {
    return this.formCadAgenda.get('configSchedule') as FormArray;
  }
}
